export var valuesSlidePartType = ["Text", "Image", "Video", "Audio", "Compare", "Hotspots"];
/*

*/ 
//# sourceMappingURL=SlidePartType.js.map